import type * as React from 'react';
import { post } from '@Domain/Api';
import aiProviderConnectionTested, {
	type AiProviderConnectionTestPayload,
	type AiProviderConnectionTestedAction,
} from '@Application/Ai/AiConfiguration/Providers/Actions/aiProviderConnectionTested';
import aiProviderConnectionTestFailed, {
	type AiProviderConnectionTestFailedAction,
} from '@Application/Ai/AiConfiguration/Providers/Actions/aiProviderConnectionTestFailed';
import type TestAiProviderConnection from '@Application/Ai/AiConfiguration/Providers/Commands/TestAiProviderConnection';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = AiProviderConnectionTestedAction | AiProviderConnectionTestFailedAction;

export default (command: TestAiProviderConnection) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<AiProviderConnectionTestPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/ai-providers/${command.providerId}/connection-tests`,
				{},
			);

			const action = aiProviderConnectionTested(payload, command.accountId, command.providerId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiProviderConnectionTestFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
